{
  "$schema": "wealthlane://schemas/form-rules",
  "effects": [],
  "observers": [],
  "validations": []
}
